import script from "./dropdownBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./dropdownBox.vue?vue&type=script&setup=true&lang=ts"

import "./dropdownBox.vue?vue&type=style&index=0&id=54d3d202&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54d3d202"]])

export default __exports__